import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "PrinterListgreen"
});
const _hoisted_1 = {
  width: "29",
  height: "28",
  viewBox: "0 0 29 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M18.5998 7.36549C18.5998 6.06278 17.5198 5.00673 16.1875 5.00673H7.74416C6.41184 5.00673 5.33179 6.06278 5.33179 7.36549V21.5181C5.33179 22.1694 5.87182 22.6975 6.53797 22.6975H15.179C15.6007 22.6975 15.8227 22.1388 15.5716 21.7999C14.9051 20.9008 14.5109 19.7877 14.5109 18.5826C14.5109 16.1748 16.0844 14.1344 18.2594 13.4334C18.4575 13.3696 18.5998 13.1901 18.5998 12.982V7.36549ZM11.3626 20.3389C11.3626 20.0132 11.6327 19.7492 11.9657 19.7492C12.2988 19.7492 12.5688 20.0132 12.5688 20.3389C12.5688 20.6646 12.2988 20.9286 11.9657 20.9286C11.6327 20.9286 11.3626 20.6646 11.3626 20.3389ZM13.0976 16.2108C13.5989 16.2108 14.0053 16.6172 14.0053 17.1185V17.6619C14.0053 18.1632 13.5989 18.5696 13.0976 18.5696H9.85796C9.35667 18.5696 8.9503 18.1632 8.9503 17.6619V17.1185C8.9503 16.6172 9.35667 16.2108 9.85796 16.2108H13.0976ZM7.14122 7.68377C7.14122 7.18248 7.54759 6.77611 8.04888 6.77611H15.883C16.3843 6.77611 16.7907 7.18248 16.7907 7.68377V12.9447C16.7907 13.446 16.3843 13.8524 15.883 13.8524H8.04888C7.54759 13.8524 7.14122 13.446 7.14122 12.9447V7.68377Z",
  fill: "#0FBD81"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("ellipse", {
  opacity: "0.8",
  cx: "19.9206",
  cy: "18.5826",
  rx: "4.41122",
  ry: "4.41067",
  fill: "#0FBD81"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M18.9457 20.1921C18.9487 20.1952 18.9517 20.1983 18.9548 20.2014C19.0743 20.3209 19.2306 20.3811 19.3872 20.382C19.5463 20.383 19.7057 20.3228 19.8271 20.2014C19.8302 20.1983 19.8332 20.1952 19.8362 20.1921L22.1923 17.8359C22.4332 17.5951 22.4332 17.2047 22.1923 16.9638C21.9515 16.723 21.5611 16.723 21.3202 16.9638L19.3909 18.8931L18.5209 18.0231C18.28 17.7822 17.8896 17.7822 17.6488 18.0231C17.4079 18.2639 17.4079 18.6543 17.6488 18.8952L18.9457 20.1921Z",
  fill: "white"
}, null, -1);
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_5);
}
var PrinterListgreen = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { PrinterListgreen as default };
